import styled from "styled-components"

import {
  Dialog,
  Select,
  spacing,
  Text,
  TextArea,
  TextField,
} from "@minuthq/meatball-ui-react"

import { useParadiseCreateLLMPromptForm } from "src/components/Paradise/ParadiseLLMPrompts/useParadiseCreateLLMPromptForm"
import { useParadiseLLMPromptCategoryOptions } from "src/components/Paradise/ParadiseLLMPrompts/useParadiseLLMPromptCategoryOptions"

const FORM_ID = "paradise-create-llm-prompt-form"

export function ParadiseCreateLLMPromptDialog({
  onClose,
}: {
  onClose: () => void
}) {
  const { form, isCreatingLLMPrompt, createLLMPromptError } =
    useParadiseCreateLLMPromptForm()

  const { categoryOptions } = useParadiseLLMPromptCategoryOptions()

  return (
    <Dialog
      title="Create LLM Prompt"
      open={true}
      onClose={onClose}
      width="large"
      confirmLabel="Create"
      confirmButtonProps={{
        loading: isCreatingLLMPrompt,
      }}
      formId={FORM_ID}
      closeLabel="Cancel"
      error={
        createLLMPromptError && (
          <div>
            <Text variant="subtitle" color="unset">
              Failed to create LLM prompt
            </Text>
            <Text color="unset">{createLLMPromptError.message}</Text>
          </div>
        )
      }
    >
      <Form id={FORM_ID} onSubmit={form.handleSubmit}>
        <FieldSet>
          <Text variant="heading3">General</Text>
          <TextField
            label="Name"
            value={form.values.name}
            onChange={(value) => form.setValues({ name: value })}
            name="name"
            required
            requiredIndicator
          />
          <Select
            label="Category"
            value={form.values.category}
            onChange={(value) => form.setValues({ category: value })}
            name="category"
            required
            requiredIndicator
            options={[
              { value: "", label: "", hidden: true },
              ...categoryOptions,
            ]}
          />
          <TextArea
            label="Description"
            value={form.values.description}
            onChange={(value) => form.setValues({ description: value })}
            name="description"
            minRows={3}
          />
        </FieldSet>
        <FieldSet>
          <Text variant="heading3">Prompt</Text>
          <TextArea
            placeholder="Enter your prompt here"
            value={form.values.prompt}
            onChange={(value) => form.setValues({ prompt: value })}
            name="prompt"
            required
            minRows={15}
            maxRows={15}
          />
        </FieldSet>
      </Form>
    </Dialog>
  )
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${spacing.L};
`

const FieldSet = styled.fieldset`
  all: unset;
  display: flex;
  flex-direction: column;
  gap: ${spacing.M};
  transition: opacity 0.3s;
  &:disabled {
    opacity: 0.5;
  }
`
